import React from 'react';

export default function HelpCenter(): JSX.Element {
  return (
    <svg width='41' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g stroke='#464F53'>
        <path d='M39.072 18.79V30a1.43 1.43 0 0 1-1.429 1.429H3.357A1.43 1.43 0 0 1 1.93 30V7.143a1.429 1.429 0 0 1 1.428-1.429h17.618M17.643 31.429l-2.857 7.143M23.357 31.429l2.858 7.143M11.929 38.572h17.143' />
        <path d='M26.214 7.143a5.714 5.714 0 1 1 5.715 5.714v4.286M31.929 24.286a.714.714 0 0 1 0-1.429M31.929 24.286a.714.714 0 1 0 0-1.429M8.834 15H20.5M8.834 21.667H20.5' />
      </g>
    </svg>
  );
}
